import { Link } from '@tanstack/react-router'
import { title } from 'radash'
import ConsultationCard from '~containers/app/my-consultations/components/consultation-card'
import useRelatedConsultations from '~repositories/hooks/use-related-consultations'

/**
 * @TODO: Link 부분 general 하게 동작할 수 있도록 수정해야함
 */

type CherryPickedConsultationsProps = Readonly<{
  id: string | number
}>

const CherryPickedConsultations = ({ id }: CherryPickedConsultationsProps) => {
  const { data: relatedConsultations } = useRelatedConsultations(id)

  if (!relatedConsultations?.length) {
    return <></>
  }

  return (
    <div className="mt-8 lg:border-t lg:border-solid lg:border-gray-300">
      <h3 className="text-headline-w-2 whitespace-pre-line p-5 text-gray-900">
        {`We’ve cherry-picked\nsome helpful questions!`}
      </h3>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {relatedConsultations.map(
          ({ id, generated_title, details, thumbnail_url, main_concern, pet }) => (
            <Link
              key={id}
              to="/samsung/smart-things/consultation/$id"
              params={{ id: id.toString() }}
            >
              <ConsultationCard className="px-5 py-4">
                {(pet.kind.depth1 || pet.kind.depth2) && (
                  <ConsultationCard.Label>{title(main_concern)}</ConsultationCard.Label>
                )}
                <div className="flex justify-between flex-gap-x-4">
                  <div className="min-w-0">
                    {generated_title && (
                      <ConsultationCard.Title className="mb-1 line-clamp-1">
                        {generated_title}
                      </ConsultationCard.Title>
                    )}
                    <ConsultationCard.Content className="line-clamp-2">
                      {details}
                    </ConsultationCard.Content>
                  </div>
                  {thumbnail_url && (
                    <ConsultationCard.Media url={thumbnail_url} alt="consultation-thumbnail" />
                  )}
                </div>
                <ConsultationCard.Pet pet={pet} />
              </ConsultationCard>
            </Link>
          )
        )}
      </div>
    </div>
  )
}

export default CherryPickedConsultations
